import {Cell, flexRender, Row} from "@tanstack/react-table";
import {useSortable} from "@dnd-kit/sortable";
import {TableCell} from "../../cnComponents/cnTable";
import {getCommonHeaderStyles} from "./ReactTableUtilities";
import {CSS} from "@dnd-kit/utilities";
import classNames from "classnames";
import {EmblaIcon} from "../emblaIcon/emblaIcon";
import { ReactTableBaseData } from "./types";

type DragAlongCellProps<T> = {
    cell: Cell<T, unknown>;
    cellIndex: number;
    row: Row<T>;
    enableColumnGrouping?: boolean;
}

export const DragAlongCell = <T extends ReactTableBaseData, >({cell, cellIndex, row, enableColumnGrouping}: DragAlongCellProps<T>) => {
    const {isDragging, setNodeRef, transform} = useSortable({
        id: cell.column.id,
    });
    return (
        <TableCell key={cell.id}
                   ref={setNodeRef}
                   style={{...getCommonHeaderStyles(cell.column, isDragging, CSS.Translate.toString(transform), true)}}
        >
            {cell.getIsGrouped() && enableColumnGrouping ? (
                <button className={classNames("btn btn-svg border-0 shadow-none")}
                        onClick={row.getToggleExpandedHandler()}
                        style={{cursor: row.getCanExpand() ? 'pointer' : 'normal'}}>
                    <div className={"flex-container-row flex-center"}>
                        <EmblaIcon iconName={row.getIsExpanded() ? "arrow-down" : "arrow-up"} additionalClasses="small"/>
                        {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                        )}&nbsp; ({row.subRows.length})
                    </div>
                </button>
            ) : cell.getIsAggregated() ? (
                // If the cell is aggregated, use the Aggregated
                // renderer for cell
                <div className={"flex-container-row"}>
                    {cellIndex === 0 && <EmblaIcon iconName={row.getIsExpanded() ? "arrow-down" : "arrow-up"} additionalClasses="margin-right-xs small"/>} 
                    {flexRender(
                        cell.column.columnDef.aggregatedCell ??
                        cell.column.columnDef.cell,
                        cell.getContext()
                    )}
                </div>
                
            ) : cell.getIsPlaceholder() ? null : ( // For cells with repeated values, render null
                // Otherwise, just render the regular cell
                flexRender(
                    cell.column.columnDef.cell,
                    cell.getContext()
                )
            )}
        </TableCell>
    )
}
